import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

export const useLogout = () => {
    const { instance, inProgress } = useMsal();

    const logout = async () => {
        try {
            if (inProgress !== InteractionStatus.None) {
                console.warn("MSAL interaction is in progress. Logout is blocked.");
                return;
            }
            await instance.initialize();
            await instance.logoutRedirect({
                postLogoutRedirectUri: "/login",
            });
        } catch (error) {
            console.error("Error during logout:", error);
        }
    };

    return logout;
};
